import NotificationsPage from "./NotificationsPage"

export default { "/notifications": NotificationsPage }
